import React, { useEffect, useState } from 'react';

import { getConfig } from '@edx/frontend-platform';
import { breakpoints } from '@openedx/paragon';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { DefaultLargeLayout, DefaultMediumLayout, DefaultSmallLayout } from './components/default-layout';
import {
  ImageExtraSmallLayout, ImageLargeLayout, ImageMediumLayout, ImageSmallLayout,
} from './components/image-layout';
import { AuthLargeLayout, AuthMediumLayout, AuthSmallLayout } from './components/welcome-page-layout';
import { DEFAULT_LAYOUT, IMAGE_LAYOUT } from './data/constants';
import IIMBLogo from '../assets/images/iimb-logo.png';
import Logo from '../assets/images/logo.png';
import ArrowRight from '../assets/images/arrow-right.png';
import LoginImage from '../assets/images/login-image.png';
import RegisterImage1 from '../assets/images/register-image-1.png';
import RegisterImage2 from '../assets/images/register-image-2.png';
import RegisterImage3 from '../assets/images/register-image-3.png';


const BaseContainer = ({
  bit = false,
  children,
  showWelcomeBanner,
  username,
}) => {
  const [baseContainerVersion, setBaseContainerVersion] =
    useState(DEFAULT_LAYOUT);

  const images = [RegisterImage1, RegisterImage2, RegisterImage3];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000)
    return () => clearInterval(intervalId);
  }, [])
  useEffect(() => {
    const initRebrandExperiment = () => {
      if (window.experiments?.rebrandExperiment) {
        setBaseContainerVersion(window.experiments?.rebrandExperiment?.variation);
      } else {
        window.experiments = window.experiments || {};
        window.experiments.rebrandExperiment = {};
        window.experiments.rebrandExperiment.handleLoaded = () => {
          setBaseContainerVersion(window.experiments?.rebrandExperiment?.variation);
        };
      }
    };
    initRebrandExperiment();
  }, []);

  if (baseContainerVersion === IMAGE_LAYOUT) {
    return (
      <div className="layout">
        <MediaQuery maxWidth={breakpoints.extraSmall.maxWidth - 1}>
          {showWelcomeBanner ? <AuthSmallLayout username={username} /> : <ImageExtraSmallLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.small.minWidth} maxWidth={breakpoints.small.maxWidth - 1}>
          {showWelcomeBanner ? <AuthSmallLayout username={username} /> : <ImageSmallLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.medium.minWidth} maxWidth={breakpoints.large.maxWidth - 1}>
          {showWelcomeBanner ? <AuthMediumLayout username={username} /> : <ImageMediumLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.extraLarge.minWidth}>
          {showWelcomeBanner ? <AuthLargeLayout username={username} /> : <ImageLargeLayout />}
        </MediaQuery>
        <div className={classNames('content', { 'align-items-center mt-0': showWelcomeBanner })}>
          {children}
        </div>
      </div>
    );
  }

  const oldHtml = () => {
    return (
      <>
        <MediaQuery maxWidth={breakpoints.small.maxWidth - 1}>
          {showWelcomeBanner ? <AuthSmallLayout username={username} /> : <DefaultSmallLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.medium.minWidth} maxWidth={breakpoints.large.maxWidth - 1}>
          {showWelcomeBanner ? <AuthMediumLayout username={username} /> : <DefaultMediumLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.extraLarge.minWidth}>
          {showWelcomeBanner ? <AuthLargeLayout username={username} /> : <DefaultLargeLayout />}
        </MediaQuery>
        <div className={classNames('content', { 'align-items-center mt-0': showWelcomeBanner })}>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="login rightBox">
        <div className="leftCol">
          <div className="logo">
            <a href={`${getConfig().LMS_BASE_URL}`} className="logo-container">
              <img src={IIMBLogo} alt="Logo" className="iimb-logo"/>
              <div className="divider"></div>
              <img src={Logo} alt="Logo" className="iimbx-logo"/>
            </a>
          </div>
          {window?.location?.pathname.includes("/authn/register") ? (
            <>
              <div key={currentIndex} className="banner-img" style={{ backgroundImage: `url(${images[currentIndex]})`, }} />
              <div className="img-arrow" style={{ backgroundImage: `url(${ArrowRight})` }} />
            </>
          ) : (
            <>
              <div className="banner-img" style={{ backgroundImage: `url(${LoginImage})` }} />
              <div className="img-arrow" style={{ backgroundImage: `url(${ArrowRight})` }} />
            </>
          )}
        </div>
        <div className="right-col">
          <div className={`login-form signIn ${bit ? "password-assistance" : ""}`}>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

BaseContainer.defaultProps = {
  showWelcomeBanner: false,
  username: null,
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showWelcomeBanner: PropTypes.bool,
  username: PropTypes.string,
};

export default BaseContainer;
